/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} Typing Test`)
};

const es_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test de Mecanografía de ${i?.label}`)
};

const de_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} Tipptest`)
};

const nl_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Typetest van ${i?.label}`)
};

const fr_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test de frappe de ${i?.label}`)
};

const it_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test di digitazione da ${i?.label}`)
};

const pt_br2_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teste de Digitação de ${i?.label}`)
};

const pt_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teste de Escrita de ${i?.label}`)
};

const ja_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}タイピングテスト`)
};

const zh_typing_variant_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}打字测试`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_h1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_h1", locale)
	if (locale === "en") return en_typing_variant_h1(inputs)
	if (locale === "es") return es_typing_variant_h1(inputs)
	if (locale === "de") return de_typing_variant_h1(inputs)
	if (locale === "nl") return nl_typing_variant_h1(inputs)
	if (locale === "fr") return fr_typing_variant_h1(inputs)
	if (locale === "it") return it_typing_variant_h1(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_h1(inputs)
	if (locale === "pt") return pt_typing_variant_h1(inputs)
	if (locale === "ja") return ja_typing_variant_h1(inputs)
	return zh_typing_variant_h1(inputs)
};